import { Logtail } from "@logtail/browser";

export const logger = window.clientConfig.BS_SOURCE_TOKEN ? new Logtail(window.clientConfig.BS_SOURCE_TOKEN, {
    endpoint: window.clientConfig.BS_INGEST_HOST!,
}) : console;

